'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const HangerIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M10.3237 8.05762C10.3237 6.95305 11.2192 6.05762 12.3237 6.05762C13.4283 6.05762 14.3237 6.95305 14.3237 8.05762C14.3237 8.86346 13.3553 9.7486 12.559 10.4765C12.3525 10.6652 12.1576 10.8434 11.9941 11.0068L3.94336 18.2529H20.0566L14.0502 12.8559",
        stroke: "currentColor"
      }
    )
  }
);
const VpHangerIcon = forwardRef(HangerIcon);

export { VpHangerIcon as default };
